import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String }
  static targets = ["source", "button"]

  connect() {
    this.#originalText = this.#labelElement.textContent
  }

  copy() {
    const text = this.hasTextValue && this.textValue !== "" ? this.textValue : this.sourceTarget.value
    navigator.clipboard.writeText(text).then(() => {
      const label = this.#labelElement
      label.textContent = "コピー済み"
      label.disabled = true
      clearTimeout(this.#timer)
      this.#timer = setTimeout(() => {
        label.textContent = this.#originalText
        label.disabled = false
      }, 2000)
    })
  }

  disconnect() {
    clearTimeout(this.#timer)
  }

  get #labelElement() {
    return this.hasButtonTarget ? this.buttonTarget : this.element
  }

  #originalText = ""
  #timer = null
}
